import GoogleAnalytics from "./ga";
import YaCounter from "./ym";

let ym = new YaCounter();
listener('click', '[data-yagoal]', function (form) {
	ym.goal(form.dataset['yagoal']);
});
listener('vg.fs.success', 'form[data-form-yagoal]', function (form) {
	ym.goal(form.dataset['formYagoal']);
});

let ga = new GoogleAnalytics();
listener('click', '[data-gagoal]', function (form) {
	ga.goal(form.dataset['gagoal']);
});
listener('vg.fs.success', 'form[data-form-gagoal]', function (form) {
	ga.goal(form.dataset['formGagoal']);
});
